// Shared by the Browser and Point carousel-banner admin pages — both derive this same
// 4-state lifecycle (never stored, always computed on the backend) from their own banner
// data. Module isolation means each page keeps its own status type/DTO; this just needs
// the same 4 literal string values to line up structurally.
export type BannerLifecycleStatus = 'Draft' | 'Scheduled' | 'Live' | 'Ended';

// antd <Tag> status colors — matches the prototype's live/sched/draft/ended palette.
export const STATUS_COLOR: Record<BannerLifecycleStatus, string> = {
  Draft: 'default',
  Scheduled: 'warning',
  Live: 'success',
  Ended: 'default',
};

// A carousel/newtab slot may only hold a Live or Scheduled banner.
export function isSlotEligible(status: BannerLifecycleStatus): boolean {
  return status === 'Live' || status === 'Scheduled';
}
